//#region IMPORT
import { Button, Dialog } from '../../../../Components/MUIs';
import { Box, Stack, Typography } from '@mui/material';
import PinchZoom from '../../../../Components/Ui/PinchZoom';
import Lottie from 'lottie-react';
import AiAnimation from '../../../../Assets/animations/Loading.json';
import { Group as GroupIcon } from '@mui/icons-material';
//#endregion

export default function M_TBM_CUSTOM_05(props) {
  return (
    <>
      <Stack sx={{ display: 'flex', alignItems: 'start', m: 2, mt: 0 }}>
        <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
          작업허가서
        </Typography>
        <Typography sx={{ color: '#828282' }}>
          PDF 자료를 통해 작업허가서를 확인해주세요.
        </Typography>
      </Stack>

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          width: '100%',
          overflow: 'hidden',
        }}
      >
        {props.loading ? (
          <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
            작업허가서를 불러오는 중...
          </Typography>
        ) : props.pdfImages.length > 0 ? (
          <PinchZoom
            contents={props.pdfImages.map((src, idx) => (
              <img
                key={idx}
                src={src}
                alt={`PDF page ${idx + 1}`}
                style={{ width: '100%', marginBottom: '10px' }}
              />
            ))}
          />
        ) : (
          <Typography sx={{ color: '#4b4949ff', mt: 2 }}>
            작업허가서가 없습니다.
          </Typography>
        )}
        <Stack
          direction={'row'}
          justifyContent="space-between"
          alignItems="center"
          sx={{
            display: 'flex',
            gap: '5rem',
            p: 2,
            width: '100%',
          }}
        >
          <Button
            sx={{
              width: '100%',
              height: '36px',
              borderRadius: '18px',
            }}
            name="이전"
            onClick={props.goToPrevPage}
          />

          <Button
            sx={{
              width: '100%',
              height: '36px',
              borderRadius: '18px',
            }}
            name="완료"
            onClick={() => {
              props.ActiveButton?.({
                type: 'check2',
                id: props.userInfo?.userid,
                content: true,
              });
              props.setModalToggle2?.(true);
            }}
          />
        </Stack>
      </Box>
      {props.modalToggle2 && (
        <Dialog
          open={props.modalToggle2}
          sx={{ height: '90vh' }}
          titleSx={{
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#D9D9D9',
            pt: 3,
            pb: 1.5,
          }}
          contentSx={{ display: 'flex', flexDirection: 'column', p: 3, px: 3 }}
          actionsSx={{ p: 0 }}
          PaperProps={{
            sx: {
              m: 2,
              borderRadius: 4,
              width: 'calc(100% - 32px)',
              maxWidth: '100%',
            },
          }}
          fullWidth={true}
          saveButtonName="선택"
          closeButtonName="닫기"
          useSaveButton={false}
          useSaveAfterClose={false}
          useCloseButton={false}
          onSave={() => { }}
          maxWidth={false}
          content={
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Lottie
                animationData={AiAnimation}
                loop
                autoplay
                style={{
                  display: 'flex',
                  width: '50px',
                  height: '30px',
                  overflow: 'hidden',
                  transform: 'scale(4)',
                }}
              />
              <Box>
                <Typography sx={{ fontSize: '18px', fontWeight: 'bold' }}>
                  교육이 종료되었습니다.
                </Typography>
                <Typography>TBM완료 후 AI콜을 진행해주세요.</Typography>
              </Box>
              <Box
                sx={{
                  pt: 2,
                  gap: 0.5,
                  display: 'flex',
                  justifyContent: 'start',
                  alignContent: 'center',
                }}
              >
                <GroupIcon />
                <Typography>
                  <Typography
                    component="span"
                    fontWeight="bold"
                    sx={{ color: '#00789E' }}
                  >
                    {props.check?.filter((item) => item.type === 'check2').length ?? 0}명
                  </Typography>{' '}
                  참가 완료
                </Typography>
              </Box>
            </Box>
          }
        />
      )}
    </>
  );
}
